import { gql } from '@apollo/client';

export default gql`
  query me {
    me {
      paymentCurrencies
      offices {
        name
        description
        defaultPaymentLocation
        isStation
      }
    }
  }
`;
